import t from "clipper-lib";
import { pathToPoly as P } from "./internal/index.js";
import { polyToPath as i } from "./internal/index2.js";
const r = 1e5;
function m(e, s) {
  if (!e.length)
    return [];
  const o = new t.Clipper(), a = e[0][1], n = i(e), c = s.map((p) => i(p));
  t.JS.ScaleUpPath(n, r), t.JS.ScaleUpPaths(c, r), o.AddPath(n, t.PolyType.ptSubject, !0), o.AddPaths(c, t.PolyType.ptClip, !0);
  const l = [];
  return o.Execute(t.ClipType.ctDifference, l, t.PolyFillType.pftNonZero, t.PolyFillType.pftNonZero), t.JS.ScaleDownPaths(l, r), l.map((p) => P(p, a));
}
export {
  m as differencePolygons
};
//# sourceMappingURL=index3.js.map
